export const livingWill = ((chart) => {
    let placeHolderText
    if (chart.LIVING_WILL.livingWillURI) {
        placeHolderText = 'Yes. Already uploaded to MIDEO'
    } else {
        placeHolderText = 'No.'
    }

    return placeHolderText
})